import { TieStallStanchionHeatAbatement } from './tieStallStanchionHeatAbatement.js';
import { medias } from './../Global/medias.js';

class TieStallStanchionHeatAbatementAssessorSlides {
  constructor(app, report, evaluation, group, user) {
    this.app = app;
    this.report = report;
    this.evaluation = evaluation;
    this.group = group;
    this.user = user;
  }

  add(tableOfContentsCalculatorPosition) {
    let assessor = this.group.getAssessorByType('13');

    if (assessor === false || assessor.assessor.data === undefined) {
      throw (
        this.group.getName() +
        this.app.$t(' - ') +
        this.app.$t('Tiestall/Stanchion Heat Abatement') +
        this.app.$t(' assessor is not ready.')
      );
    }

    this.report.tableOfContentsHelper(
      'Tiestall/Stanchion Heat Abatement',
      tableOfContentsCalculatorPosition,
      this.group,
    );

    TieStallStanchionHeatAbatement(this.app, this.report, this.evaluation, this.group, assessor);
    medias(this.app, this.report, this.group, '13', this.user);
  }
}

export default TieStallStanchionHeatAbatementAssessorSlides;
